export enum CreationMenuTypeEnums {
    /**
     * Standard mode --> table view
     */
    STANDARD = 0,
    /**
     * Mobile view, like the original design
     */
    MOBILE = 1,
    /**
     * A simplified mode with just a predifined set of fields
     */
    SIMPLE = 2,
    /**
     * Wizard for quick edit
     */
    WIZARD = 3,
    /**
     * Wizard for mymill units
     */
    MYMILL_WIZARD = 4,
    /**
     * Fallback value in error case
     */
    UNKNOWN = 999,
}
